import { Component } from 'react';

class HomeTimer extends Component {
  componentDidMount() {
    this.props.requestVendor(this.props.vendorId);
  }

  render() {
    return null;
  }
}

export default HomeTimer;



// WEBPACK FOOTER //
// ./src/components/HomeTimer/index.js